<template>
  <div>
    <el-dialog
    :append-to-body="true"
    :before-close="closeView"
     class="addTaskView"
      :close-on-click-modal="false"
      :visible.sync="showTaskSwitch"
      width="550px">
      <span slot="title" class="dialog-footer">
        <span>是否开启任务</span>
      </span>
        <el-row>
           <span class="star">*</span> 定时运行开关
        </el-row>
        <el-switch
            @change="change"
            v-model="taskStatus">
        </el-switch>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button type="primary" @click="addTask" size="small">确 定</el-button> -->
        <el-button @click="closeView" size="small">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { taskStatus } from '@/api/dataStatistics'
export default {
  components: {
  },
  props: {
    taskDetail: {
      type: Object
    },
    showTaskSwitch: {
      tyhpe: Boolean
    }
  },
  data: function () {
    return {
      taskStatus: this.taskDetail.taskStatus.toString() === '2'
    }
  },
  computed: {

  },
  methods: {
    ChangeTaskStatus (params) {
      console.log('ChangeTaskStatus')
      taskStatus(params).then(res => {
        res = res.data
        console.log('修改任务状态返回：', res)
        if (res.code === 200) {
          this.$emit('update')
          this.closeView()
        }
      })
    },
    change (value) {
      const confirmText = value ? '确认开启？' : '确认关闭？'
      const params = {
        taskId: this.taskDetail.taskId,
        taskStatus: value ? 2 : 1
      }
      const that = this
      // this.$confirm(confirmText)
      //   .then(_ => {
      //     console.log('确认')
      //     that.ChangeTaskStatus(params)
      //   })
      //   .catch(_ => {
      //     console.log('取消')
      //   })

      this.$confirm(confirmText, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        console.log('确认')
        that.ChangeTaskStatus(params)
      }).catch(() => {
        this.taskStatus = !this.taskStatus
        this.$message({
          type: 'info',
          message: '已取消开关'
        })
      })
    },
    closeView () {
      this.$emit('closeView')
    }
  }
}
</script>
<style lang="less" scope>
.addTaskView{
  .star{
       color:#d93026;
    }
  }
</style>
